export const iconList = [
  "AccessAlarm",
  "AccessAlarms",
  "Accessibility",
  "Accessible",
  "AccountBalance",
  "AccountBalanceWallet",
  "AccountBox",
  "AccountCircle",
  "Add",
  "AddAlarm",
  "AddAlert",
  "AddBox",
  "AddCircle",
  "AddCircleOutline",
  "AddShoppingCart",
  "Alarm",
  "AlarmAdd",
  "AlarmOff",
  "AlarmOn",
  "AllInbox",
  "AllOut",
  "Android",
  "Announcement",
  "Apps",
  "Archive",
  "ArrowBack",
  "ArrowDownward",
  "ArrowDropDown",
  "ArrowDropUp",
  "ArrowForward",
  "ArrowUpward",
  "Assessment",
  "Assignment",
  "AssignmentInd",
  "AssignmentLate",
  "AssignmentReturn",
  "AssignmentReturned",
  "AssignmentTurnedIn",
  "Autorenew",
  "Backup",
  "Book",
  "Bookmark",
  "BookmarkBorder",
  "BugReport",
  "Build",
  "Cached",
  "CalendarToday",
  "CalendarViewDay",
  "CameraEnhance",
  "CardGiftcard",
  "CardMembership",
  "CardTravel",
  "ChangeHistory",
  "CheckCircle",
  "CheckCircleOutline",
  "ToggleOff",
  "ToggleOn"
];
